import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

// Preload only routes flagged `data: { preload: true }`, and only once the main thread goes
// idle — boot hydration (multicall + WS handshake) gets the network to itself until then.
@Injectable({ providedIn: 'root' })
export class HotRoutePreload implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (!route.data?.['preload']) return of(null);
    return new Observable((subscriber) => {
      let cancelled = false;
      whenIdle(() => {
        if (cancelled) return;
        load().subscribe(subscriber);
      });
      return () => { cancelled = true; };
    });
  }
}

function whenIdle(run: () => void): void {
  const ric = (globalThis as { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number })
    .requestIdleCallback;
  if (ric) ric(run, { timeout: 5000 });
  else setTimeout(run, 2000);
}
